import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {HmConfigPage} from "../page/overview/hc-config/hm-config.page";


const hmModuleEntry: TestModuleDefinition = {
    key: 'hm',
    label: 'Integration (hm)',
    components: [
        {
            key: 'HmConfigPage',
            component: HmConfigPage,
            selector: 'mvs-hm-config',
            type: 'PageComponent',
            label: 'hm config page'
        }
    ]
}

export const HM_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: hmModuleEntry, multi: true}
];